<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <material-card class="v-card-profile">
          <v-avatar slot="offset" class="mx-auto d-block" size="130">
            <img style="backgroundColor:white" :src="profileImage" />
          </v-avatar>
          <v-card-text class="text-xs-center">
            <v-form>
              <v-container py-0>
                <v-layout wrap>
                  <v-flex xs12 md4>
                    <v-text-field label="Company" value="Pipefish" readonly disabled />
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-text-field
                      label="Email Address"
                      readonly
                      :value="userProfile.EmailAddress"
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="First Name"
                      readonly
                      :value="userProfile.GivenName"
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Last Name"
                      readonly
                      :value="userProfile.Surname"
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Mobile"
                      v-model="userProfile.Mobile"
                      type="number"
                      hint="only enter numbers 0-9"
                    >
                      <template v-slot:append>
                        <v-icon color="green" v-show="showTick">mdi-cloud-check</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 text-xs-right>
                    <v-btn
                      small
                      :loading="showLoading"
                      :disabled="userProfile.Mobile == null || userProfile.Mobile == ''"
                      color="pipefishGreen"
                      @click="updateMobile"
                    >Update Mobile</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data: () => ({
    joke: null,
    showTick: false,
    showLoading: false,
    weather: {}
  }),
  computed: {
    ...mapState("api", ["profileImage", "userName", "userInfo"]),
    ...mapState("app", ["userProfile"])
  },
  created() {},
  methods: {
    ...mapActions("admin", ["setSortedPipefishUsers"]),
    updateMobile() {
      this.showLoading = true;
      this.showTick = false;
      var self = this;
      this.$timesheetApi
        .updateMobile(this.userProfile.id, this.userProfile.Mobile)
        .then(res => {
          self.$timesheetApi.getAllUsers().then(users => {
            self.setSortedPipefishUsers(users);
            self.showTick = true;
            self.showLoading = false;
          });
        })
        .catch(err => {
          self.showLoading = false;
        });
    }
  }
};
</script>
